import React,{ useState, useEffect } from 'react';
import { 
    Menu,
    Button
} from 'antd';

function ModemUpgradeMenu( { handleMenuItemClick, openKeys, selectedKeys } ) {

    const getItem = (label, key, icon, children, type) => {
        return {
            key,
            icon,
            children,
            label,
            type,
        };
    }

    const items = [
        getItem('Modem upgrade information', 'sub1', null, [
            getItem('Upgrade instructions', 'upgrade-instructions'),
            getItem('Troubleshooting tips', 'upgrade-troubleshooting'),
            getItem('Benefits of upgrading', 'upgrade-benefits')
        ])
    ];

    return (
        <>
            { console.log(openKeys) }
            <Menu
                onClick={handleMenuItemClick}
                style={{
                    width: '100%',
                }}
                selectedKeys={ selectedKeys }
                openKeys={ openKeys }
                mode="inline"
                items={items}
            />
        </>
        
    )
}

export default ModemUpgradeMenu